// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1OXTY","containerItemsCenter":"Skeleton_containerItemsCenter__1qL69"};